import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemActionCategoryIndexComponent } from './crud-index/crud-index.component';
import { SystemActionCategoryCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: SystemActionCategoryIndexComponent,
  },
  {
    path: 'create',
    component: SystemActionCategoryCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: SystemActionCategoryCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: SystemActionCategoryCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SystemActionCategoriesRoutingModule {}
